import { API, graphqlOperation } from "aws-amplify";
export default class SurveyWorkshop {
  constructor(filter) {
    this._filter = filter;
    this._nextToken = null;
    this._graphData = null;
  }

  getGraphData() {
    const that = this;
    return new Promise(async function (resolve) {
      let results = await that.getWorkshopSurveyFeedbackData();
      that._graphData = results;
      while (that._nextToken !== null) {
        let nextResultSet = await that.getWorkshopSurveyFeedbackData();
        that._graphData.push(...nextResultSet);
      }
      resolve(that._graphData);
    });
  }

  async getWorkshopSurveyFeedbackData() {
    const listSurveyWorkshops = /* GraphQL */ `
      query ListSurveyWorkshops(
        $filter: ModelSurveyWorkshopFilterInput
        $limit: Int
        $nextToken: String
      ) {
        listSurveyWorkshops(
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          items {
            id
            company
            name
            date
            participants
            isDeleted
            surveyWorkshopFeedback {
              items {
                id
                feedback
                elementsChangeInclude
                createdAt
                increaseUnderstanding
                rateWorkshop
                recommend
                trainer
                updatedAt
                usefulPrinciplesTechniques
                workshopContent
              }
            }
            createdAt
            updatedAt
          }
          nextToken
        }
      }
    `;
    let gqlConfig = {
      nextToken: this._nextToken,
      limit: 2000,
    };
    if (this._filter) {
      gqlConfig = {
        filter: this._filter,
        nextToken: this._nextToken,
        limit: 2000,
      };
    }

    const { data: { listSurveyWorkshops: results } } = await API.graphql(
      graphqlOperation(listSurveyWorkshops, gqlConfig)
    );
    this._nextToken = results.nextToken;
    let workshops = [];
    results.items.forEach(function (workshop) {
      workshop.surveyWorkshopFeedback.items.map((feedback) => {
        workshops.push({
          company: workshop.company,
          workshopName: workshop.name,
          participants: workshop.participants,
          increaseUnderstanding: feedback.increaseUnderstanding,
          rateWorkshop: feedback.rateWorkshop,
          recommend: feedback.recommend,
          trainer: feedback.trainer,
          usefulPrinciplesTechniques: feedback.usefulPrinciplesTechniques,
          elementsChangeInclude: feedback.elementsChangeInclude,
          feedback: feedback.feedback,
          workshopContent: feedback.workshopContent,
        });
      });
    });
    return workshops;
  }

  async getWorkshopSurveyData(filter) {
    const listSurveyWorkshopFeedbacks = /* GraphQL */ `
      query ListSurveyWorkshopFeedbacks(
        $filter: ModelSurveyWorkshopFeedbackFilterInput
        $limit: Int
        $nextToken: String
      ) {
        listSurveyWorkshopFeedbacks(
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          items {
            id
            trainer
            rateWorkshop
            workshopContent
            increaseUnderstanding
            usefulPrinciplesTechniques
            elementsChangeInclude
            recommend
            feedback
            surveyWorkshop {
              id
              company
              name
              date
              participants
              isDeleted
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
      }
    `;

    let gqlConfig = {
      limit: 2000,
    };
    if (filter) {
      gqlConfig = {
        limit: 2000,
        filter: filter,
      };
    }

    const result = await API.graphql(
      graphqlOperation(listSurveyWorkshopFeedbacks, gqlConfig)
    );
    return result.data.listSurveyWorkshopFeedbacks.items;
  }

  getUniqueCompanyNames() {
    const uniqueColumn = this._graphData.map(function (value) {
      return value.company.trim();
    });
    let uniqueArray = [...new Set(uniqueColumn)];
    return uniqueArray.sort()
  }

  getUniqueWorkshopNames(company) {

    const workshopNames = this._graphData
    .filter(function (value) {
      return value.company.trim().toLowerCase() === company.trim().toLowerCase();
    })
    .map(function (value) {
      if (value.workshopName) {
        return value.workshopName.trim();
      }
    });

    let uniqueArray = [...new Set(workshopNames)];
    return uniqueArray.sort();
  }

  getUniqueTrainer() {
    const uniqueColumn = this._graphData.map(function (value) {
      if (value.workshopName) {
        return value.trainer.trim();
      }
    });
    let uniqueArray = [...new Set(uniqueColumn)];
    return uniqueArray.sort();
  }
}
